export default __webpack_public_path__ + "static/media/KillerSprint1.c9de2a0a.jpg";